module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiBjbGFzcz0ic3ZnX19TdHlsZWRTVkdJY29uLXNjLTVwNjh4eC0xIGdzSlZpeSBpY29uIGRlc2lnbi9hcnJvdy9yaWdodCBhcnJvdy1yaWdodCBzdmctaWNvbiIgdmlld0JveD0iMCAwIDYgMTAiIHdpZHRoPSI2IiAgaGVpZ2h0PSIxMCIgPjxwYXRoIGQ9Ik0uODEuMDk2TC4xMDUuNzkyIDQuMjkgNS4wMDcuMDcxIDkuMTg2bC42OTcuNzAyIDQuOTI0LTQuODc1eiIgZmlsbC1vcGFjaXR5PSIwLjQiIGZpbGw9IiMwMDAwMDAiPjwvcGF0aD48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/unfold.svg
// module id = ayUq
// module chunks = 1